/**
 * Single source of truth for building public-profile links.
 *
 * Public profiles resolve ONLY through the addressableHandle table (by username /
 * handle) — see `getPublicProfile` in src/actions/buddy.ts. There is no route that
 * resolves a profile by raw user id, so `/profile/<userId>` always 404s.
 *
 * Therefore a profile link must be built from a resolvable handle, or omitted
 * entirely — never fall back to the user id. When this returns `null`, callers
 * should render the name / avatar as non-clickable rather than link to a dead
 * route. The `<ProfileLink>` component (src/components/profile/profile-link.tsx)
 * applies that fallback for you.
 */
export function profileHref(handle: string | null | undefined): string | null {
  const trimmed = handle?.trim();
  return trimmed ? `/profile/${trimmed}` : null;
}
